export class RegistrationNotFoundException extends Error {
  constructor(message) {
    super(message ?? 'Registration not found.');
  }
}